import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import React, { PureComponent } from 'react';
import { ThemeProvider } from '@material-ui/styles';
import { theme } from '@/components/common/Question/MaterialUI/materialTheme';
import themesRepo from '@/theme';
export default function withPalette(UIComponent) {
  return /*#__PURE__*/function (_PureComponent) {
    _inherits(_class, _PureComponent);
    function _class(props) {
      var _this;
      _classCallCheck(this, _class);
      _this = _possibleConstructorReturn(this, _getPrototypeOf(_class).call(this, props));
      var _theme = '';
      try {
        _theme = sessionStorage.getItem('survey-quest-theme');
      } catch (error) {
        console.error('error: ', error.message);
      }
      var presetTheme = themesRepo[_theme];
      _this.state = {
        presetTheme: presetTheme
      };
      return _this;
    }
    _createClass(_class, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var _theme = '';
        try {
          _theme = sessionStorage.getItem('survey-quest-theme');
        } catch (error) {
          console.error('error: ', error.message);
        }
        var presetTheme = themesRepo[_theme];
        window.addEventListener('setItem', function (_ref) {
          var newValue = _ref.newValue;
          presetTheme = themesRepo[newValue];
        });
        this.setState({
          presetTheme: presetTheme
        });
      }
    }, {
      key: "render",
      value: function render() {
        return theme(this.state.presetTheme) ? React.createElement(ThemeProvider, {
          theme: theme(this.state.presetTheme)
        }, React.createElement(UIComponent, this.props)) : React.createElement(UIComponent, this.props);
      }
    }]);
    return _class;
  }(PureComponent);
}